import { type JSX } from "react";
import type { ISvgIcon } from "@/types";

export function ICEn({
  width = "28",
  height = "28",
  className = "",
}: ISvgIcon): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 33 32"
      fill="none"
    >
      <g clipPath="url(#clip0_3793_11584)">
        <rect x="0.621094" width="32" height="32" rx="16" fill="#1A47B8" />
        <path
          d="M-1.013 0H-5.77881V5.33333L34.2295 32L39.0212 32V26.6667L-1.013 0Z"
          fill="white"
        />
        <path
          d="M-4.18927 0L39.0212 28.8756V32H37.4689L-5.77881 3.09453V0H-4.18927Z"
          fill="#F93939"
        />
        <path
          d="M34.7545 0H39.0212V5.33333C39.0212 5.33333 11.3088 23.0999 -1.51214 32H-5.77881V26.6667L34.7545 0Z"
          fill="white"
        />
        <path
          d="M39.0212 0H37.5743L-5.77881 28.9005V32H-4.18927L39.0212 3.1179V0Z"
          fill="#F93939"
        />
        <path
          d="M10.5136 0H22.766V9.87054H39.0212V22.1229H22.766V32H10.5136V22.1229H-5.77881V9.87054H10.5136V0Z"
          fill="white"
        />
        <path
          d="M13.0843 0H20.158V12.3077H39.0212V19.6923H20.158V32H13.0843V19.6923H-5.77881V12.3077H13.0843V0Z"
          fill="#F93939"
        />
      </g>
      <defs>
        <clipPath id="clip0_3793_11584">
          <rect x="0.621094" width="32" height="32" rx="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
